export default "__VITE_ASSET__BVCmDaJY__"